import { NEWS_CATEGORIES } from '../../data/newsSources.js';

/**
 * CategoryFilter — horizontally scrollable chip rail.
 *
 * Stateless — controlled by the parent via `value` + `onChange` so the
 * News screen owns the filter state alongside its data fetch.
 *
 * The chips are not virtualised — six entries is well under any list-perf
 * threshold. If we extend to a dynamic taxonomy (driver tags, team tags),
 * revisit with a virtualised rail.
 */
export default function CategoryFilter({ value, onChange }) {
  return (
    <div className="scroll-hide -mx-5 mb-3 flex gap-2 overflow-x-auto px-5">
      {NEWS_CATEGORIES.map((cat) => {
        const isActive = value === cat.id;
        return (
          <button
            key={cat.id}
            onClick={() => onChange(cat.id)}
            className={`pressable no-select shrink-0 rounded-full px-4 py-1.5 text-xs font-semibold transition-all ${
              isActive
                ? 'bg-f1-red text-white shadow-glow-red-soft'
                : 'bg-bg-card2 text-ink-secondary ring-1 ring-stroke hover:text-ink-primary'
            }`}
            aria-pressed={isActive}
          >
            {cat.label}
          </button>
        );
      })}
    </div>
  );
}
